/* DO THEY SWIPE THE GALLERY? — make it a number instead of an opinion.

   WHY THIS EXISTS. Tracy 2026-09-23: "the people that go to PDP, we already know
   that they don't go past the buy zone … the question is, do they slide through
   the images?" Clarity cannot answer that: it records clicked TEXT, and a swipe is
   not a click at all. Measured the same day, 152 of ~230 product-page clicks were
   on unlabelled elements it could not attribute, and the only gallery signal in the
   whole day was 3 clicks on "Open media in modal".

   So the gallery is a horizontal scroller (.product__media-list, overflow-x auto,
   scrollWidth 3120 across 8 slides at 390px) and the furthest slide reached is a
   readable number. This reports it to Clarity as custom tags, which are filterable
   and segmentable the next morning:

     pdp_slides_total  how many slides the PDP offered
     pdp_slide_max     furthest slide index actually reached (1 = never moved)
     pdp_swiped        yes / no — did they move off slide 1 at all

   WHY TAGS AND NOT AN EVENT. Tags attach to the SESSION, so "sessions that swiped"
   can be crossed with add-to-cart, scroll depth and channel — which is the question
   behind the question. An event would only count occurrences.

   Deliberately cheap: one passive scroll listener, debounced, and it reports at
   most once per slide-change settle. No-ops entirely when clarity is absent, so a
   blocked analytics script can never break the gallery. */
(function () {
  function init() {
    var list = document.querySelector('.product__media-list');
    if (!list) return;
    if (typeof window.clarity !== 'function') return;   // never hard-depend on it

    var slides = document.querySelectorAll('.product__media-item').length;
    if (slides < 2) return;                             // nothing to swipe through

    var maxIdx = 1;
    var reported = 0;
    var timer = null;

    function report() {
      if (maxIdx === reported) return;
      reported = maxIdx;
      /* One tag per try. Wrapping all three together means a single throw on the
         first loses the other two — and pdp_swiped is the one the question actually
         turns on, so it must not depend on the two before it succeeding. */
      set('pdp_slides_total', String(slides));
      set('pdp_slide_max', String(maxIdx));
      set('pdp_swiped', maxIdx > 1 ? 'yes' : 'no');
    }

    function set(k, v) {
      try { window.clarity('set', k, v); } catch (e) { /* never throw into the page */ }
    }

    function onScroll() {
      var w = list.clientWidth || 1;
      /* +0.5 so a slide counts once it is mostly in view, not only when perfectly
         snapped — a half-swipe that reveals the next image still saw it. */
      var idx = Math.floor(list.scrollLeft / w + 0.5) + 1;
      if (idx > maxIdx) maxIdx = Math.min(idx, slides);
      clearTimeout(timer);
      timer = setTimeout(report, 400);
    }

    list.addEventListener('scroll', onScroll, { passive: true });

    /* Record the "never moved" case too, otherwise the data only ever contains
       people who swiped and the denominator is invisible. */
    setTimeout(report, 4000);
    window.addEventListener('pagehide', report);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
